import {CustomerAddress} from '../../customer/models/customer-address.model';
import {NoteViewModel} from '../../note/models/views/note-view.model';
import {ExemptionModel} from '../../shared/models/exemption.model';
import { CustomerCharacteristic } from '../../customer/models/customer-characteristic.model';
import { CustomerContact } from '../../customer/models/customer-contact.model';

export class CustomerModel {
    constructor() {
        // this.customerAddresses = new Array<CustomerAddress>();
        this.notes = new Array<NoteViewModel>();
        this.characteristics = new Array<CustomerCharacteristic>();
    }

    public customerNumberID: number;

    public customerName: string;
    public customerNameId: number;
    public customerFirstName: string;
    public customerMiddleName: string;
    public customerLastName: string;
    public driversLicenseNumber: string;
    public tribalCardEnrollmentNumber: string;
    public originalTribalCardEnrollmentEnumber: string;
    public mailingAddress: CustomerAddress;
    public physicalAddress: CustomerAddress;

    public mailingAddressDisplayValue: string;
    public characteristics: CustomerCharacteristic[];
    public legacySequenceNumber: string;
    public legacyCustomerNumber: string;

    public deceased: boolean;
    public customerTypeId: number;
    public photo: any;

    public phones: any[];
    public contacts: CustomerContact[];
    public email: any;
    public dateOfBirth: Date;
    public notes: NoteViewModel[];
    public exemption: ExemptionModel;
    public wipUpdatePending: boolean;
}
